import { EditOutlined } from "@ant-design/icons"
import { Button, Card, Descriptions } from "antd"
import React, { useState } from "react"

import type { BranchDetail } from "../../types/types.ts"
import { AddBranchModal } from "../../components/AddBranchModal.tsx"

export const BranchOverviewTab = ({
  branch,
  onSaved
}: {
  branch: BranchDetail
  onSaved: () => void
}) => {
  const [editOpen, setEditOpen] = useState(false)

  return (
    <Card
      extra={
        <Button icon={<EditOutlined />} onClick={() => setEditOpen(true)}>
          Edit
        </Button>
      }
    >
      <Descriptions column={2} bordered size="small">
        <Descriptions.Item label="Business name">
          {branch.company_details?.business_name || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Phone">
          {branch.company_details?.company_phone || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="City">
          {branch.company_details?.city || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="State">
          {branch.company_details?.state || "—"}
        </Descriptions.Item>
        <Descriptions.Item label="Manager">
          {branch.manager
            ? `${branch.manager.first_name} ${branch.manager.last_name}`
            : "— (GCC Owner retains access)"}
        </Descriptions.Item>
        <Descriptions.Item label="Team size">
          {branch.team_count}
        </Descriptions.Item>
        <Descriptions.Item label="Project types" span={2}>
          {branch.project_types
            ?.map((type) => (typeof type === "string" ? type : type.label))
            .join(", ") || "—"}
        </Descriptions.Item>
      </Descriptions>
      <AddBranchModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        branchId={branch.id}
        onSaved={() => {
          setEditOpen(false)
          onSaved()
        }}
      />
    </Card>
  )
}
